import {
  SET_TOURNAMENT_INFORMATION_FOR_ADMIN,
  SET_RETURNING_TO_CALENDAR_FOR_ADMIN
} from './constants';

const initialState = {
  tournament: null,
  returningToCalendar: false
};

const reducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case SET_RETURNING_TO_CALENDAR_FOR_ADMIN:
      return {
        ...state,
        returningToCalendar: true
      };
    case SET_TOURNAMENT_INFORMATION_FOR_ADMIN:
      return {
        ...state,
        tournament: payload || initialState.tournament
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/admin/reducer.js